import React from 'react';

import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import  { history } from '../../store/configureStore';

import { getFilteredDataForCatalog } from '../../selectors/entities/filters'

import ProductLazyCanvas from '../ProductLazyCanvas';

class ProductCanvasList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    shouldComponentUpdate(nextProps, nextState) {
        const {fabricEnums} = this.props;
        return fabricEnums.length !== nextProps.fabricEnums.length;
    }

    onSelectProduct = async (val, i, preset) => {
        history.push({
            pathname: window.location.pathname,
            search: `?` + new URLSearchParams({
                    fabric: val, 
                    preset: preset
                }).toString(),
        })
    }

    renderList = () =>  {
        const { fabricEnums } = this.props;

        if(fabricEnums.length === 0)
            return this.renderEmptyList();

        return fabricEnums.map((product, i) => (
            <ProductLazyCanvas 
                key={i}
                index={i}
                product={product}
                onChange={this.onSelectProduct}
                displayName={product.displayName}
                value={product.article}
                price={product.catalog.price}
                isNew={product.isNew}
                isSale={product.isSale}
                preset={product.catalog.preset}
                />
            )
        )
    }

    renderEmptyList = () => (
        <div className="b-rit-product-list__empty">
            <p className="b-rit-product-list__empty-title">Ничего не найдено</p>
            <p>Но вы можете создать свой дизайн рубашки<br/>с помощью нашего конструктора</p>
            <button 
                className="rit-button rit-button_theme_black"
                onClick={() => { history.push(`/b_designer`) }}>
                Свой дизайн рубашки
            </button>
        </div>
    )

    render() {
        return (
            <div className='b-rit-product-list'>
                {this.renderList()}
            </div>
        )
    }
}

ProductCanvasList.propTypes = {
    fabricEnums: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        fabricEnums: getFilteredDataForCatalog(state),
        ...ownProps,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({}, dispatch)
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation()(ProductCanvasList));